import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/help/AHelpCategory/index", {
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/help/AHelpCategory/add",{
        params: {}
    } )
}
function EDIT_DATA(params) {
    return  axios.post("/help/AHelpCategory/edit",  {id:params}  )
}
function SUBMIT_ADD(params) {
    return  axios.post("/help/AHelpCategory/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/help/AHelpCategory/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/help/AHelpCategory/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/help/AHelpCategory/delete",{
        params: {
            ids:params
        }
    } )
}
function ORDER_LIST (params) {
    return  axios.post("/help/AHelpCategory/listOrder",{list_orders:params} )
}

export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
    ORDER_LIST
}